import React from "react";
import Section from "../components/Section";

function ChildrensPrivacy() {
  return (
    <Section id="childrens-privacy" icon="👶" title="Children's Privacy">
      <p>
        The App is not directed to children under the age of <strong>13</strong> (or the applicable
        age of digital consent in your jurisdiction). We do not knowingly collect any data from
        children. If you believe a child has used the App and you have concerns, please contact us
        at the address below and we will take appropriate action.
      </p>
    </Section>
  );
}

export default ChildrensPrivacy;
